import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RedirectGuard } from './core/guards/redirect.guard';
import { BaseComponent } from './views/layout/base/base.component';
import { ForgotPasswordComponent } from './views/pages/auth/login/forgot-password/forgot-password.component';
import { LoginOtpComponent } from './views/pages/auth/login/login-otp/login-otp.component';
import { LoginComponent } from './views/pages/auth/login/login.component';
import { ResetPasswordComponent } from './views/pages/auth/login/reset-password/reset-password.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./views/pages/auth/auth.routes') },
   {   path: 'login',
     component: LoginComponent,
  }, 
  {
    path: '',
    redirectTo: 'redirector',
    pathMatch: 'full'
  },
  {
    path: 'redirector',
    canActivate: [RedirectGuard],
    loadComponent: () =>
      import('./app.component').then(m => m.AppComponent) // or any existing component

  },

  {
    path: 'login-otp',
    component: LoginOtpComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },

  {
    path: '',
    component: BaseComponent,
    children: [
      { 
        path: 'smartdocs', 
        loadChildren: () => import('./views/pages/smart-docs/smartdocs.routes').then(m => m.smartdocsRoutes),
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'error',
    loadComponent: () => import('./views/pages/error/error.component').then(c => c.ErrorComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'error/:type',
    loadComponent: () => import('./views/pages/error/error.component').then(c => c.ErrorComponent)
  },
  { path: '**', redirectTo: 'error/404', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
